
function useInternalUserCheck(email) {
    if (!email) {
        return false;
    }
    const whiteList = process.env.REACT_APP_WHITELIST.split(" ");
    if (whiteList.includes(email)) {
        return true;
    }
    return false;
}

export default useInternalUserCheck;